/**
 * Build a v2 API path relative to ROOT_API_URL (/api/v1).
 * RTK Query concatenates `baseUrl` + `url`; absolute `/api/v2/...` paths
 * incorrectly become `/api/v1/api/v2/...`.
 *
 * @param {string} resourcePath - e.g. "manifests", "manifests/:id"
 * @returns {string}
 */
export const v2ApiPath = (resourcePath) => `../v2/${resourcePath}`;
